let apiBase = {
  queryDocDetail: '/api/p/doc/queryDetail'
}
let singleDocumentServerObject = null

class DocumentServer {
  constructor() {
  }

  queryDocDetail(params = {}) {
    return $http({
      method: 'get',
      url: apiBase.queryDocDetail,
      params: params,
    })
  }
}

function singleDocumentServer() {
  if (singleDocumentServerObject === null) {
    singleDocumentServerObject = new DocumentServer()
  }
  return singleDocumentServerObject
}

export default singleDocumentServer()
